// This file contains constants related to stamps management meant to be consumed by the world
// outside of the stamps slice

export const SeriesTabsIds = {
  ALL: 'all',
  FAVOURITES: 'favourites',
  DRAFTS: 'drafts',
};

export const SeriesDetailsTabsIds = {
  DETAILS: 'details',
  STAMPS: 'stamps',
};
